import classNames from 'classnames';
import styles from './Avatar.module.scss';
import { Button } from 'ui/components/1-atoms';
import { useEffect, useState } from 'react';
import { Icon } from 'ui/components/1-atoms/Media/Icon';
import IconAvatar from 'ui/icons/icon-avatar.svg';

export interface AvatarProps {
	className?: string;
	onSignIn?: () => void;
	onSignOut?: () => void;
	onSetAvatarActive?: () => void;
	isAvatarActive: boolean;
	disabled?: boolean;
	profile?: {
		name?: string | null;
		email?: string | null;
		image?: string | null;
	};
	dictionary?: { [key: string]: string };
}

export const Avatar: React.FC<AvatarProps> = ({
	className,
	profile,
	onSignIn,
	onSignOut,
	isAvatarActive,
	onSetAvatarActive,
	dictionary,
	disabled,
}) => {
	const [isLoggedIn, setIsLoggedIn] = useState<boolean>(profile != null);
	const [accounts] = useState<string[]>([]);

	useEffect(() => {
		setIsLoggedIn(profile != null);
	}, [profile]);

	return (
		<div className={classNames(styles.Avatar, className)}>
			{isLoggedIn && (
				<div
					className={classNames(styles.Avatar_container, {
						[styles.isOpen]: isAvatarActive,
					})}
				>
					<Button
						style="primaryWeb"
						className={classNames(styles.Avatar_button, styles.Avatar_toggle, {
							[styles.isOpen]: isAvatarActive,
						})}
						onClick={onSetAvatarActive}
					>
						<Icon className={styles.Avatar_LoggedInAvatar}>
							<IconAvatar />
						</Icon>
						<span className={classNames(styles.Avatar_toggleText)}>{`${profile?.name}`}</span>
					</Button>

					<div className={styles.Avatar_dropdownContainer}>
						{accounts &&
							accounts.map((account, index) => (
								<div
									key={index}
									className={classNames(styles.Avatar_wrapper, {
										[styles.isOpen]: isAvatarActive,
									})}
								>
									<Button style="primary" className={classNames(styles.Avatar_button, styles.Avatar_dropdownButton)}>
										{account}
									</Button>
								</div>
							))}
					</div>
				</div>
			)}

			{!isLoggedIn && (
				<Button
					style="primaryWeb"
					disabled={disabled}
					className={classNames(styles.Avatar_button, styles.Avatar_button___loginButton)}
					onClick={() => {
						onSignIn?.();
					}}
				>
					{disabled && <span className={styles.Avatar_spinner} />}
					{dictionary?.actionLogin}
				</Button>
			)}

			{isLoggedIn && (
				<Button style="primary" className={classNames(styles.Avatar_button, styles.Avatar_button___logoutButton)} onClick={onSignOut}>
					Logout
				</Button>
			)}
		</div>
	);
};
